import o from "@babel/runtime/helpers/esm/extends";
import i from "@babel/runtime/helpers/esm/objectWithoutProperties";
import m from "react";
import s from "@semcore/spin";
var n = ["theme", "size"], p = {
  xl: "m",
  l: "s",
  m: "xs",
  s: "xxs"
};
function l(e) {
  e.theme;
  var t = e.size, r = i(e, n);
  return /* @__PURE__ */ m.createElement(s, o({
    size: typeof t == "string" ? p[t] : t,
    theme: "currentColor"
  }, r));
}
export {
  p as SPIN_SIZE_MAP,
  l as default
};
